// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__2EjEr","button":"Form_button__6P6Tn"};